import { AfterViewInit, Directive, ElementRef, Renderer2 } from '@angular/core';

@Directive({
    selector: 'input[mwlFlatpickr]+input'
})

export class FlatpickrInputDirective implements AfterViewInit {
    constructor(
        public el: ElementRef,
        private _renderer: Renderer2
    ) { }

    public ngAfterViewInit(): void {
        const siblingInput = this.el.nativeElement.nextElementSibling;
        if (window.innerWidth < 992) {
            this._renderer.setAttribute(siblingInput, 'readOnly', 'readonly');
        }
    }
}
